import PropTypes from 'prop-types'
import React from 'react'
import { PaymentStripeFormCheckout } from 'containers/Payment/Stripe/Form/Checkout/index.js'
import { STRIPE_API_KEY } from 'modules/payment/services/stripe/constants/index.js'

let Elements, stripePromise

export function PaymentStripeForm (formProps) {
  const [isStripeLoaded, setIsStripeLoaded] = React.useState(false)

  React.useEffect(() => {
    const loadStripeLibraries = async () => {
      if (!Elements) {
        const [stripeReact, stripeJs] = await Promise.all([
          import(/* webpackChunkName: "stripe" */ '@stripe/react-stripe-js'),
          import(/* webpackChunkName: "stripe" */ '@stripe/stripe-js')
        ])
        Elements = stripeReact.Elements
        stripePromise = stripeJs.loadStripe(STRIPE_API_KEY)
        setIsStripeLoaded(true)
      } else {
        setIsStripeLoaded(true)
      }
    }
    loadStripeLibraries()
  }, [])

  if (!isStripeLoaded) {
    return null
  }

  return (
    <Elements stripe={stripePromise}>
      <PaymentStripeFormCheckout {...formProps} />
    </Elements>
  )
}

PaymentStripeForm.propTypes = {
  shouldNotTryPaymentRequest: PropTypes.bool,
  FloatingButton: PropTypes.Component,
  onSubmit: PropTypes.func.isRequired,
  productLabel: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  amount: PropTypes.number,
  currency: PropTypes.string
}
